<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <h2
      mat-dialog-title
      class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color"
    >
      {{ _data?.type == "phone" ? "Forgot Password" : "" }}
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    mat-dialog-close
  >
    <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div class="w-full">
    <img
      draggable="false"
      class="md:w-40 sm:w-28 w-28 mx-auto mb-3"
      src="assets/images/ui/forgot-password.png"
      alt=""
    />
    <div
      *ngIf="_data.type == 'methods'"
      class="text-center md:mb-4 sm:mb-0 mb-0 md:px-16 sm:px-0 px-0"
    >
      <h4
        class="md:text-2xl sm:text-xl text-xl mb-2 text-orange-color font-semibold"
      >
        Forgot Password
      </h4>
      <span
        class="md:text-xl sm:text-base text-base text-blue-theme-color font-medium"
        >Select which option you would like to use to reset your password?</span
      >
    </div>

    <div *ngIf="_data.type == 'phone'">
      <span
        class="md:text-xl text-center block sm:text-base text-base text-input-color font-medium"
        >Please enter your moblie number to receive a verification code</span
      >
      <div
        class="country-code-field mt-4 min-h-[78px] flex-1 form-field"
        appearance="fill"
      >
        <label class="label font-medium">Mobile Number</label>
        <div
          class="relative flex items-center border-b-2 py-1 overflow-hidden border-gray-color"
        >
          <div class="absolute flex h-full max-w-16 overflow-hidden w-16">
            <mat-select
              tabindex="-1"
              (selectionChange)="changeCountry()"
              [(value)]="this.selectedCountryCode"
              tabindex="-1"
              class="!flex !items-center"
              (click)="$event.stopPropagation()"
            >
              <mat-option
                *ngFor="let country of this.countries"
                [value]="country.code.toString()"
              >
                <div class="flex flex-row gap-1">
                  <img
                    class="w-6 aspect-square object-contain"
                    [src]="country.logo"
                    alt=""
                  />
                  <p>{{ country.code }}</p>
                </div>
              </mat-option>
            </mat-select>
          </div>
          <input
            (click)="$event.stopPropagation()"
            [formControl]="this.phoneNumber"
            [maxlength]="this.selectedCountryCode == '+233' ? '9' : '10'"
            matInput
            style="padding-left: 75px !important"
            class="flex-1"
            placeholder="Enter mobile number"
            type="text"
            appNoSpaces
          />
        </div>
        <div class="flex flex-col">
          <span
            class="text-red text-xs font-medium mt-1"
            *ngIf="this.phoneNumber.hasError('pattern')"
            >Invalid number</span
          >
          <span
            class="text-red text-xs font-medium mt-1"
            *ngIf="
              this.phoneNumber.touched && this.phoneNumber.hasError('required')
            "
            >Mobile number is required</span
          >
        </div>
      </div>
    </div>

    <div *ngIf="_data.type == 'email'">
      <span
        class="md:text-xl mb-4 text-center block sm:text-base text-base text-input-color font-medium"
        >Please enter your email address to receive a verification code.</span
      >
      <div class="row">
        <label class="font-medium text-[14px] mb-[4px]">Email</label>
        <mat-form-field class="flex-1 form-field" appearance="fill">
          <input
            [formControl]="email"
            matInput
            class="mt-1"
            placeholder="Please enter email"
          />
          <mat-error *ngIf="this.email.hasError('required')"
            >Email is Required</mat-error
          >
          <mat-error *ngIf="this.email.hasError('email')"
            >Please enter a valid email address</mat-error
          >
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="mt-2 !pb-5 !px-0 gap-3 justify-center">
  <ng-container *ngIf="_data.type == 'methods'">
    <button
      color="primary"
      mat-dialog-close
      (click)="_matDialogRef.close('SMS')"
      class="!bg-orange-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color !rounded-none"
      mat-flat-button
    >
      <mat-icon class="mat-18">sms</mat-icon>
      <span class="pl-2">Via SMS</span>
    </button>
    <button
      color="primary"
      mat-dialog-close
      (click)="_matDialogRef.close('E-Mail')"
      class="!bg-blue-theme-color md:!w-[130px] !ml-0 sm:!w-full !w-full !h-11 text-white-color !rounded-none"
      mat-flat-button
    >
      <mat-icon class="mat-18">email</mat-icon>
      <span class="pl-2">Via E-Mail</span>
    </button>
  </ng-container>

  <ng-container *ngIf="_data.type == 'phone' || _data.type == 'email'">
    <button
      color="primary"
      (click)="onSubmit()"
      class="!bg-blue-theme-color md:!w-[130px] !ml-0 sm:!w-full !w-full !h-11 text-white-color"
      mat-flat-button
    >
      Send
    </button>
  </ng-container>
</mat-dialog-actions>
